module.exports = __webpack_public_path__ + "img/head-f302bb93.png";